import { useEffect } from "react";
import LoadingFallback from "../../../components/elements/LoadingFallback";

const Signin = () => {
  const shopifyUrl = process.env.REACT_APP_SHOPIFY_URL?.trim();

  useEffect(() => {
    if (!shopifyUrl) return;
    window.location.assign(shopifyUrl);
  }, [shopifyUrl]);

  if (!shopifyUrl && process.env.NODE_ENV === "development") {
    return (
      <div className="mx-auto max-w-md px-4 py-16 text-center text-md-dark">
        <p className="mb-3 font-medium">Sign-in uses your Shopify storefront</p>
        <p className="mb-4 text-sm text-gray-600">
          To review logged-in UI locally, add <code className="text-xs">REACT_APP_SHOPIFY_URL</code> to{" "}
          <code className="text-xs">.env.local</code>, restart <code className="text-xs">npm start</code>,
          then open <code className="text-xs">/signin</code> again—you&apos;ll be redirected to the store to
          log in, then return here with a session.
        </p>
        <p className="text-sm text-gray-600">
          Or use the deployed app URL in your browser to review UI without running this project.
        </p>
      </div>
    );
  }

  return <LoadingFallback />;
};

export default Signin;
